import {Multimedia} from '@/types/matrix';

import {Box, Card, CardMedia} from '@mui/material';
import VideoPreviewWithPlayIcon from '@/components/matrix-chat/ui/video-preview-with-play-icon';

interface BoxWithOneElementProps {
  urls: string[];
  multimediaType: Multimedia;
  handleOpenFullScreen: (url: string) => void;
}

const BoxWithOneElement: React.FC<BoxWithOneElementProps> = ({
  urls,
  multimediaType,
  handleOpenFullScreen
}) => {
  const url = urls[0];
  const cardProps = {
    height: '100%'
  };

  const cardMediaProps = {
    cursor: 'pointer',
    objectFit: 'cover',
    height: '100%'
  };

  const isVideo = multimediaType === 'video';

  return (
    <Box
      sx={{
        display: 'flex',
        width: {xs: '150px', md: '300px'},
        maxHeight: {xs: '150px', md: '300px'}
      }}
    >
      <Box
        key={url}
        sx={{
          width: {xs: '150px', md: '300px'},
          maxHeight: {xs: '150px', md: '300px'},
          position: 'relative'
        }}
      >
        <Card
          // onMouseLeave={handleMouseLeave}
          sx={{...cardProps}}
        >
          {isVideo ? (
            <VideoPreviewWithPlayIcon
              url={url}
              handleOpenFullScreen={handleOpenFullScreen}
            />
          ) : (
            <CardMedia
              component="img"
              image={url}
              alt={`${multimediaType}`}
              onClick={() => handleOpenFullScreen(url)}
              sx={{...cardMediaProps}}
            />
          )}
        </Card>
      </Box>
    </Box>
  );
};

export default BoxWithOneElement;
